export default function optimizerABTestCookieValues() {
  // Retrieve all cookies
  const cookies = document.cookie.split(';');

  // Filter cookies to only include ones that start with '__test'
  const filteredCookies = cookies.filter((cookie) => cookie.trim().startsWith('__ab_'));

  // Loop through the filtered cookies and extract their values
  let foundValues = '';
  filteredCookies.forEach((cookie, index) => {
    const value = cookie.split('=')[1];
    foundValues += value;
    if (index < filteredCookies.length - 1) {
      foundValues += ' | ';
    }
  });

  return foundValues;
}
